import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "./../style.css";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Select from "react-select";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { Card, Tooltip } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import RunReportNow from "./../RunReportNow";
import { Domain, Language, TravelExplore } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import Sidebar from "./../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "./../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import { Commonfun, removeDuplicateDate } from "./../Commonfun";
import { AppContext } from "../../../Context/Context";
import { timezonechange } from "./../Commonfun";
import { timezoneval } from "./../Commonfun";
import { datezonechange } from "./../Commonfun";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import Loader from "./../CommonLoader";
import CommonAlert from "../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import DatagridComp from "./../DatagridComp";
import PdfandCsv from "./../PdfandCsv";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";
import Commoncard from "./../Commoncard";
import VisibilityScoreIcon from "./../Asset/esocardicon/RankingSummary/Visibility_Score.svg";
import TotalCitationsIcon from "./../Asset/esocardicon/RankingSummary/Total_keywords.svg";
import TotalMentionsIcon from "./../Asset/esocardicon/RankingSummary/Ranked_Keywords.svg";
import TotalPromptsIcon from "./../Asset/esocardicon/RankingSummary/First_Page_Ranked_keywords.svg";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ScoreGauge from "../../../Components/chart/gaugeChart";

export default function AicitationReport() {

  const isMobile = useMediaQuery({ maxWidth: 600 });
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [summaryData, setSummaryData] = useState(null);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([]);
  const [Domainsectiondata, SetDomainsectiondata] = useState([]);
  const [initialDateval, SetInitialDateval] = useState([]);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [autoheightval, SetAutoheightval] = useState(true);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [analysisSummaryPlan, setanalysisSummaryPlan] = useState({
    status: false,
    error: "",
  });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [visibilityChart, setVisibilityChart] = useState([]);
  const [mentionChart, setMentionChart] = useState([]);
  const [first, setfirst] = useState({
    name: "",
    path: "",
    closeName: "Close",
    statusDomain: false,
  });
  const [checkD, setcheckD] = useState(false);
  const [domainNameUrl, setDomainNameUrl] = useState({
    domain_name: "",
    domain_url: "",
  });
  const [dEngineoption, SetdEngineoption] = useState({
    label: "Select Date",
    value: "Select Date",
  });
  const [prevdEngineoption, setprevdEngineoption] = useState({
    label: "Select Date",
    value: "Select Date",
  });
  const [faqData, setfaqData] = useState("2");
  const [datagridval, setDatagridval] = useState(1);
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const handleClose = () => {
    setOpen(false);
  };
  const apihandleClose = () => {
    setapiOpen(false);
  };

  const [chartData, setChartData] = useState();
  const [kpicardData, setKpiCardData] = useState();
  const [citedUrlModalOpen, setCitedUrlModalOpen] = useState(false);
  const [selectedCitedUrls, setSelectedCitedUrls] = useState([]);
  const [selectedPopup, setSelectedPopup] = useState("citedUrls");
  const [validation, setValidation] = useState({
    dateerror: "",
  });
  let detailurl = `${process.env.REACT_APP_DOMAIN}content-detail/`;
  const [aimodel, setAimodel] = useState("");
  const [citedurl, setCitedurl] = useState("");
  const [citationFormOpen, setCitationFormOpen] = useState(false);
  const [citationUrl, setCitationUrl] = useState("");
  const [citationQuery, setCitationQuery] = useState("");
  const [brandName, setBrandName] = useState("");
  const [citationErrors, setCitationErrors] = useState({ url: "", query: "", brandName: "" });

  const arr = [];

  useEffect(() => {
    tableData();
    CharacterData();
    CardKpiData();
    faqdatafun();
    fetchAiVisibilitySummary();
  }, []);
  const tableData = async () => {
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}technical/ai_citation_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&ai_model=${aimodel}&cited=${citedurl}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      console.log("datavalue:", datavalue?.data?.result);
      const dataval = datavalue?.data?.result;

      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setjobidData(datavalue?.data?.job_id);
        SetAutoheightval(false);
        setCardData(newData);
        setTableLoading(false);
      }

      if (datavalue?.data?.job_date)
        setjobDate(
          moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"),
        );
      else setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"));

      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setjobidData(datavalue?.data?.job_id);
        SetAutoheightval(false);
        setCardData(newData);
        setTableLoading(false);
      } else {
        SetAutoheightval(true);
        setCardData("");
        setjobDate();
        setTableLoading(false);
      }
    } catch (err) {
      setCardData("");
      if (err.code == "ERR_NETWORK") {
        navigate("/*");
      }
    }
  }
  const CardKpiData = async (jobID = "") => {
    try {
      const cardData = await axios.get(`${process.env.REACT_APP_API_URL}technical/ai_citation_dashboard_kpi/?user_domain_id=${esodata.domaindata.value.header_selected}${jobID ? `&job_id=${jobID}` : ""}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      });
      setKpiCardData(cardData?.data);
    }
    catch (err) {
    }
  }
  const CharacterData = async (jobID = "") => {
    try {
      const charData = await axios.get(`${process.env.REACT_APP_API_URL}technical/ai_citation_dashboard_charts/?user_domain_id=${esodata.domaindata.value.header_selected}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      });
      setChartData(charData?.data);
      console.log("charData updated:", charData?.data);
    }
    catch (err) {
    }
  }

  const fetchAiVisibilitySummary = async () => {
    setLoading(true);
    setTableLoading(true);
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}technical/ai_visibility_summary/?user_domain_id=${esodata.domaindata.value.header_selected}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });

      if (datavalue?.data) {
        setVisibilityChart(datavalue?.data?.visibility_chart);
        setMentionChart(datavalue?.data?.mention_chart);
      }

    } catch (err) {
      setCardData("");
      if (err.code == "ERR_NETWORK") {
        navigate("/*");
      }
    }

    setLoading(false);
  }



  const Columns = [
    {
      field: "query",
      headerName: "Query",
      description: "The question tested in AI tools",
      minWidth: 250,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
    {
      field: "url",
      headerName: "Web Page URL",
      description: "The page checked for visibility",
      minWidth: 320,
      flex: 1.5,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        let baseUrl =
          cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData.row.url}>
              <div className="prefered_url_external02">
                <a
                  target="_blank"
                  href={cardData?.row?.url}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span
                    className="spanlink"
                    style={{
                      color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </a>
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "cited_count",
      headerName: "Cited Count",
      description: "Number of times your website appeared in the AI response.",
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
    },
    {
      field: "brand_mentioned",
      headerName: "Brand Mentioned",
      minWidth: 200,
      flex: 0.8,
      sortable: true,
      headerAlign: "center",
      align: "center",
      description: "Indicates if your brand name was mentioned in the response.",
      renderCell: (cardData) => {
        console.log("params.brand_mentioned:", cardData.row.brand_mentioned);
        const value = cardData.row.brand_mentioned;
        if (value == null) return "-";
        return value ? (
          <CheckCircleIcon style={{ color: "green" }} />
        ) : (
          <CancelIcon style={{ color: "red" }} />
        );
      },
    },
    {
      field: "mention_count",
      headerName: "Mention Count",
      description: "Number of times your brand name appeared in the response.",
      minWidth: 125,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
    },
    {
      field: "cited_url",
      headerName: "Cited URLs",
      minWidth: 180,
      flex: 1,
      sortable: false,
      headerAlign: "center",
      align: "center",
      description: "List of all website links included in the AI response.",
      renderCell: (cardData) => {
        const value = cardData?.row?.cited_urls;
        if (Array.isArray(value) && value.length > 0) {
          return (
            <button
              onClick={() => {
                setSelectedCitedUrls(value);
                setCitedUrlModalOpen(true);
                setSelectedPopup("citedUrls");
              }}
              style={{
                backgroundColor: "#ff601f",
                color: "white",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "11px",
                fontWeight: "600",
              }}
            >
              View ({value.length})
            </button>
          );
        }
        return "-";
      },
    },
    {
      field: "competitors",
      headerName: "Competitor URLs",
      minWidth: 180,
      flex: 1,
      sortable: false,
      headerAlign: "center",
      align: "center",
      description: "Other websites recommended by AI tools along with or instead of yours.",
      renderCell: (cardData) => {
        const value = cardData?.row?.competitors;
        if (Array.isArray(value) && value.length > 0) {
          return (
            <button
              onClick={() => {
                setSelectedCitedUrls(value);
                setCitedUrlModalOpen(true);
                setSelectedPopup("compUrls");
              }}
              style={{
                backgroundColor: "#ff601f",
                color: "white",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "11px",
                fontWeight: "600",
              }}
            >
              View ({value.length})
            </button>
          );
        }
        return "-";
      },
    },
    {
      field: "ai_model",
      headerName: "Provider",
      minWidth: 160,
      flex: 0.9,
      sortable: true,
      headerAlign: "center",
      align: "center",
      description: "The AI platform that generated the response.",
      renderCell: (params) => {
        const value = params.value;
        return value ? String(value) : "-";
      },
    },
    {
      field: "cited",
      headerName: "Cited",
      minWidth: 100,
      flex: 0.8,
      sortable: true,
      headerAlign: "center",
      align: "center",
      description: "Shows whether your website link appeared in the AI response.",
      renderCell: (params) => {
        const value = params.value;
        if (value == null) return "-";
        return value ? (
          <CheckCircleIcon style={{ color: "green" }} />
        ) : (
          <CancelIcon style={{ color: "red" }} />
        );
      },
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 180,
      flex: 1,
      sortable: true,
      headerAlign: "center",
      align: "center",
      description: "The date and time when this result was generated.",
      renderCell: (params) => {
        const value = params.value;
        if (value) {
          const date = new Date(value);
          return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
        }
        return "-";
      },
    },
  ];



  const rows = cardData ?? [];


  const callUserdataApi = async (jobid = "", domainsecdata = "") => {

    setLoading(true);
    setTableLoading(true);
    // if (domainsecdata == "") domainsecdata = Domainsectiondata;
    if (jobid == "") jobid = jobidData;
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}content/v2/analysis_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobid}&domain_section_id=${domainsecdata}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (jobidData == "") {
        const completevalues = await axios
          .get(
            `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=analysis_summary&user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${esodata.sectiondomaindata.value}`,
            {
              headers: {
                Authorization: `${ApiToken}`,
              },
            },
          )
          .catch((error) => {
            if (
              error?.response?.status == 599 ||
              error?.response?.status == 400 ||
              error?.response?.status == 500
            ) {
              setapiOpen(true);
              setapierrorMsg(error?.response?.data?.error);
            } else if (
              error?.code == "ERR_NETWORK" ||
              error?.response?.status == 404
            ) {
              navigate("/errorpages");
            }
          });
        // var Selectedmets = [];

        // completevalues?.data?.jobs.forEach((element) => {
        //   Selectedmets.push({
        //     value: element.id,
        //     label: datezonechange(element.completed_at),
        //   });
        // });
        const uniqueByCompletedAt = removeDuplicateDate(completevalues?.data?.jobs);
        SetInitialDateval(uniqueByCompletedAt[0]);
        setSelectval(uniqueByCompletedAt[0]);
        SetdEngineoption(uniqueByCompletedAt[0]);
        setprevdEngineoption(uniqueByCompletedAt[0]);
        setcompletedate(uniqueByCompletedAt);
      }
      const dataval = datavalue?.data?.table_data;

      // Store the extra dashboard data
      if (datavalue?.data) {
        setSummaryData({
          total_vital_score: datavalue.data.total_vital_score,
          read_ease_chart: datavalue.data.read_ease_chart,
          grade_level_distribution: datavalue.data.grade_level_distribution,
          top_5_urls: datavalue.data.top_5_urls,
          low_5_urls: datavalue.data.low_5_urls,
          weekly_trend: datavalue.data.weekly_trend,
        });
      }

      if (datavalue?.data?.job_date)
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      else setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"));

      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setjobidData(datavalue?.data?.job_id);
        SetAutoheightval(false);
        setCardData(newData);
        setTableLoading(false);
      }

      if (datavalue?.data?.job_date)
        setjobDate(
          moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"),
        );
      else setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"));

      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setjobidData(datavalue?.data?.job_id);
        SetAutoheightval(false);
        setCardData(newData);
        setTableLoading(false);
      } else {
        SetAutoheightval(true);
        setCardData("");
        setjobDate();
        setTableLoading(false);
      }
    } catch (err) {
      setCardData("");
      if (err.code == "ERR_NETWORK") {
        navigate("/*");
      }
    }

    setLoading(false);
  };

  const reportNow = async () => {
    var errs = 1;
    let errors = {};

    // if (selectval.value === "") {
    if (!selectval || !selectval.value) {
      errors.dateerror = "This field is required.";
      errs = 2;
    } else {
      // errors.dateerror = "This field is required.";
      errs = 1;
      setValidation(errors);
    }
    if (errs === 2) {
      return setValidation(errors);
    }
    setLoading(true);
    setjobidData(selectval.value);
    setIsOpen(false);
    setprevdEngineoption(dEngineoption);
    var domainsec = "";
    callUserdataApi(selectval.value, (domainsec = ""));
    CharacterData(selectval.value);
    CardKpiData(selectval.value);
  };
  function openModal() {
    setfaqData(2);
    setToggle(false);
    setIsOpen(true);
  }
  function closeModal() {
    setSelectval("");
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);
  }
  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}technical/ai_citation_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&ai_model=${aimodel}&cited=${citedurl}&formats=pdf&timezone=${timezoneval()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        },
      );
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun(
          "Ai Citation Report",
          "pdf",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;

        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (
          response?.status == 599 ||
          response?.status == 500 ||
          response?.status == 400 ||
          response?.status == 404 ||
          response?.status == 502
        ) {
          response.json().then((data) => {
            setapiOpen(true);
            setapierrorMsg(data?.error);
          });
        } else if (response?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloading(false);
  };
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}technical/ai_citation_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&ai_model=${aimodel}&cited=${citedurl}&formats=csv&timezone=${timezoneval()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        },
      );
      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const now = new Date();
        const datetimeval = now.toLocaleDateString();
        const hours = now.getHours().toString().padStart(2, "0");
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const seconds = now.getSeconds().toString().padStart(2, "0");
        var filedata = await Commonfun(
          "Ai Citation Report",
          "csv",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;

        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (
          response?.status == 599 ||
          response?.status == 500 ||
          response?.status == 400 ||
          response?.status == 404 ||
          response?.status == 502
        ) {
          response.json().then((data) => {
            setapiOpen(true);
            setapierrorMsg(data?.error);
          });
        } else if (response?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  };
  const [RunReportPopShow, SetRunReportPopShow] = useState(false);
  const [RunReportType, SetRunReportType] = useState("analysis_summary");
  const [toggle, setToggle] = useState(false);
  const wrapperRef = useRef(null);
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=90`;

    try {
      const doaminsectiondatavalue = await axios
        .get(datavar, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs);
      }
    } catch (err) { }
  };





  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }
    setToggle((pre) => !pre);


  };


  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }


  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const gaugeChart = () => {
    return (
      <div>
        {/* <span>Most Critical issue category</span> */}
        <ScoreGauge score={kpicardData?.ai_visibility_score} />
      </div>
    )
  }

  const urls1 = Array.isArray(visibilityChart)
    ? visibilityChart
    : [];
  const urls2 = Array.isArray(mentionChart)
    ? mentionChart
    : [];

  const chartOptions = (urls) => {
    return {
      chart: {
        type: "bar",
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: true, // better for long URLs
          barHeight: "60%"
        }
      },
      xaxis: {
        categories: urls?.map(item => item.country) || [],
        labels: {
          show: true,   // 👈 hides numbers/text on x-axis
          offsetX: 50
        },
        // axisBorder: {
        //   show: false   // optional: remove axis line
        // },
        // axisTicks: {
        //   show: false   // optional: remove ticks
        // }
      },
      yaxis: {
        labels: {
          maxWidth: 150
        }
      },
      grid: {
        padding: {
          left: 20,
          right: 20
        }
      },
      tooltip: {
        x: {
          formatter: (val, opts) => urls[opts.dataPointIndex]?.country
        },
        y: {
          formatter: (val) => val
        }
      }
    };
  }

  const chartSeries = (urls) => {
    return [
      {
        name: "Total Reports",
        data: urls?.map(item => item.total_reports) || []
      },
      {
        name: "Visibility Count",
        data: urls?.map(item => item.visibility_count) || []
      },
      {
        name: "Visibility Percentage",
        data: urls?.map(item => item.visibility_percentage) || []
      },
    ];
  }

  return (
    <div
      className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Ai Citation Report</title>
      </Helmet>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {loading === true ? <Loader /> : null}


      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Ai Citation Report
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Ai Citation Report', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>

            </Grid>

            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >

                <button
                  title="Run Report"
                  className="btn_dashboard"
                  onClick={() => {
                    if (first.statusDomain) {
                      setcheckD(first.statusDomain);
                    } else {
                      setfaqData(2);
                      setToggle(false);
                      setCitationFormOpen(true);
                    }
                  }}
                >
                  Check Your Ai Citation Report
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      {/* START: KPI Cards Section */}
      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
          {/* <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "AI Visibility Score",
                value: kpicardData?.ai_visibility_score || 0,
                iconSrc: VisibilityScoreIcon,
                iconColor: 0,
                bgColor: 0
              }}
              nonclikable={true}
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "Total Citations",
                value: kpicardData?.total_citations || 0,
                iconSrc: TotalCitationsIcon,
                iconColor: 2,
                bgColor: 2
              }}
              nonclikable={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "Total Mentions",
                value: kpicardData?.total_mentions || 0,
                iconSrc: TotalMentionsIcon,
                iconColor: 3,
                bgColor: 3
              }}
              nonclikable={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "Total Prompts",
                value: kpicardData?.total_prompts || 0,
                iconSrc: TotalPromptsIcon,
                iconColor: 4,
                bgColor: 4
              }}
              nonclikable={true}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Card
              sx={{
                borderRadius: "16px",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                transition: "0.3s",
                cursor: "default",
                height: "100%",
                // border: 1px solid #e0e0e0;
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                },
                overflow: "hidden",
                border: "none"
              }}
            >
              <Box
                sx={{
                  backgroundColor: '#f3e8ff',
                  p: 2.5,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    fontSize: "2.5rem",
                    background: "linear-gradient(to right, #1f2937, #4b5563)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                    letterSpacing: 1,
                  }}
                >
                  <div>{kpicardData?.ai_visibility_score}<span style={{ fontSize: '14px', marginLeft: '5px' }}></span></div>
                </Typography>

                <Box
                  sx={{
                    // backgroundColor: '#7c3aed',
                    color: "#fff",
                    // p: 1.5,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                  }}
                >
                  {/* {icon} */}
                  {gaugeChart()}
                </Box>
              </Box>

              <Box
                sx={{
                  background: "#fff",
                  px: 2.5,
                  py: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textTransform: "uppercase",
                }}
              >
                <Typography
                  sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                >
                  AI Visibility Score
                </Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* START: ApexCharts Dashboard Summary Widgets */}

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          {/* 2. Weekly Trend */}
          <Grid item xs={12} md={3.5}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Weekly Score Trend</Typography>
              {/* <Chart
                type="area"
                height={220}
                series={[{ name: "Score", data: (chartData?.trend || []).map(i => i?.visibility_score || 0) }]}
                options={{
                  chart: { toolbar: { show: false } },
                  colors: ["#ff601f"],
                  stroke: { curve: 'smooth', width: 3 },
                  fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.1 } },
                  xaxis: {
                    categories: (chartData?.trend || []).map(i => new Date(i?.date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short"
  }) || ""),
                    labels: {
                      show: true,
                      rotate: -45,
                      rotateAlways: false,
                      hideOverlappingLabels: true,
                      style: { fontSize: '10px' }
                    }
                  },
                  yaxis: { min: 0, max: 100 }
                }}
              />  */}
              <Chart
                type="area"
                height={220}
                series={[
                  {
                    name: "Score",
                    // data: [4, 5, 6, 6, 77]
                    data: (chartData?.trend || []).map(i => i?.visibility_score || 0)
                  }
                ]}
                options={{
                  chart: {
                    toolbar: { show: false }
                  },
                  colors: ["#ff601f"],
                  stroke: { curve: 'smooth', width: 3 },
                  fill: {
                    type: 'gradient',
                    gradient: {
                      shadeIntensity: 1,
                      opacityFrom: 0.4,
                      opacityTo: 0.1
                    }
                  },
                  xaxis: {
                    // categories: ['Apr 12', 'Apr 13', 'Apr 14', 'Apr 15', 'Apr 16'],
                    categories: (chartData?.trend || []).map(i =>
                      new Date(i?.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })
                    ),
                    tickPlacement: 'on', // 🔥 important
                    labels: {
                      offsetX: 50 // 👈 manual adjustment
                    }
                  },
                   yaxis: {
                      min: 0,
                      max: function (max) {
                        return max === 0 ? 10 : Math.ceil(max * 1.2);
                      },
                      tickAmount: 4,
                    },
                  grid: {
                    padding: { left: 0, right: 0 }
                  }
                }}
              />

              {/* <Chart
                type="area"
                height={220}
                series={[
                  {
                    name: "Score",
                    data: (chartData?.trend || []).map(i => { return { x:  new Date(i?.date).getTime(), y: i?.visibility_score } })
                  }
                ]}
                options={{
                  chart: {
                    toolbar: { show: false },
                    width: '100%',
                    redrawOnParentResize: true,
                    redrawOnWindowResize: true
                  },
                  colors: ["#ff601f"],
                  stroke: { curve: 'smooth', width: 3 },
                  fill: {
                    type: 'gradient',
                    gradient: {
                      shadeIntensity: 1,
                      opacityFrom: 0.4,
                      opacityTo: 0.1
                    }
                  },
                  xaxis: {
                    type: 'datetime', // ✅ KEY FIX
                    labels: {
                      offsetX: 50 // 👈 manual adjustment
                    }
                  },
                  yaxis: {
                    min: 0,
                    max: 80
                  },
                  grid: {
                    padding: { left: 0, right: 0 }
                  }
                }}
              /> */}

            </Box>
          </Grid>



          {/* 4. Grade Level Distribution (New) */}
          <Grid item xs={12} md={3}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>AI Provider Distribution</Typography>
              <Chart
                type="donut"
                height={240}
                series={(chartData?.pie_Chart || chartData?.pie_chart || []).map(i => Number(i?.cited_count || i?.count || 0))}
                options={{
                  labels: (chartData?.pie_Chart || chartData?.pie_chart || []).map(i => i?.model || i?.label || ""),
                  colors: (chartData?.pie_Chart || chartData?.pie_chart || []).map(i => {
                    const providerColorMap = {
                      'openai': '#10a37f',
                      'claude': '#d97757',
                      'perplexity': '#c9d429',
                      'gemini': '#4285f4',
                      'copilot': '#ae36ee'
                    };
                    const val = (i?.model || i?.label || "").toLowerCase();
                    return providerColorMap[val] || '#ff601f';
                  }),
                  legend: { position: 'bottom', fontSize: '10px' },
                  dataLabels: { enabled: false },
                  noData: { text: "No Citation Data Available" }
                }}
              />
            </Box>
          </Grid>
          {/* 5. AI Interaction Metrics (New Bar Chart) */}
          <Grid item xs={12} md={5.5}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>AI Interaction Metrics</Typography>
              <Chart
                type="bar"
                height={240}
                series={[{
                  name: "Count",
                  data: (chartData?.bar_chart || []).map(i => i?.count || 0)
                }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '45%',
                      borderRadius: 4,
                      distributed: true, // 👈 IMPORTANT
                      dataLabels: { position: 'top' }
                    }
                  },
                  colors: ["#3f51b5", "#d97757", "#00C9A7", "#FF4D4F", '#ae36ee', '#c9d429'], // 👈 each bar gets color
                  dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: { fontSize: '12px' }
                  },
                  xaxis: {
                    categories: (chartData?.bar_chart || []).map(i => i?.label || ""),
                    position: 'bottom',
                    // labels: { style: { fontSize: '11px' } },
                    labels: {
                      offsetX: 50, // 👈 manual adjustment
                      style: { fontSize: '11px' }
                    }
                  },
                  yaxis: {
                    title: { text: 'Count' },
                    labels: { formatter: (val) => Math.floor(val) }
                  },
                  noData: { text: "No Metric Data Available" }
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Visibility Chart</Typography>
              <Chart
                options={chartOptions(urls1)}
                series={chartSeries(urls1)}
                type="bar"
                height={250}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Mention Chart</Typography>
              <Chart
                options={chartOptions(urls2)}
                series={chartSeries(urls2)}
                type="bar"
                height={250}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>

      {/* END: ApexCharts Dashboard Summary Widgets */}
      <Container maxWidth={false} className="dashboard-container table-search-break">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap table-100-height">
                {/* <DatagridComp className="datagrid_custom_scroll"
                  columns={Columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 320]}
                  tableLoading={tableLoading}
                  customFilter={false}
                  DownloadShowFile={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                /> */}

                <DatagridComp
                  className="datagrid_custom_scroll"
                  columns={Columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  customFilter={false}
                  DownloadShowFile={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand"> Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      <div className="">
        <div className="">

          {toggle && (
            <Rightsidebar
              close={() => setToggle(false)}
              setToggle={setToggle}
              initialfaqDateval={initialfaqDateval}
            />
          )}
        </div>


        {!openCommonAlerts && (
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle className="keyword-dialog-header">
              {"Error Message "}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                No Data Found
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-action-button">
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
        )}
        {!openCommonAlerts && (
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        )}
        <Dialog
          open={checkD}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="domain-verify-alert"
        >
          <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "15px",
                  lineHeight: "1px",
                  width: "max-content",
                }}
              >
                <p>{`Please verify your domain ${domainNameUrl.domain_name} to access these features`}</p>
                <a href={domainNameUrl.domain_url}>
                  {domainNameUrl.domain_url}
                </a>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button
              onClick={() => {
                navigate(first.path);
              }}
            >
              {first.name}
            </Button>
            <Button onClick={() => setcheckD(false)}>{first.closeName}</Button>
          </DialogActions>
        </Dialog>
      </div>

      <RunReportNow
        RunReportPopShow={RunReportPopShow}
        SetRunReportPopShow={SetRunReportPopShow}
        RunReportType={RunReportType}
        isDomainSection={true}
      />
      <Dialog
        open={citationFormOpen}
        onClose={() => {
          setCitationFormOpen(false);
          setCitationUrl("");
          setCitationQuery("");
          setBrandName("");
          setCitationErrors({ url: "", query: "", brandName: "" });
        }}
        maxWidth="sm"
        fullWidth
        className="run_report_now_modal"
      >
        <DialogTitle className="keyword-dialog-header" style={{ textAlign: 'center' }}>
          Check Your AI Citation Report
        </DialogTitle>
        <DialogContent>
          <div className="ai-form-container" style={{ border: 'none', boxShadow: 'none', padding: '10px 0' }}>
            <div className="ai-form-group">
              <label className="ai-form-label">Web Page URL (Optional)</label>
              <input
                type="text"
                className="ai-form-input"
                placeholder="https://example.com/page"
                value={citationUrl}
                onChange={(e) => setCitationUrl(e.target.value)}
              />
              <div className="ai-form-hint">
                Must start with http:// or https://
              </div>
              {citationErrors.url && <div className="ai-form-error">{citationErrors.url}</div>}
            </div>

            <div className="ai-form-group">
              <label className="ai-form-label">Search Query <span style={{ color: '#ff601f' }}>*</span></label>
              <input
                type="text"
                className="ai-form-input"
                placeholder="Enter the search prompt or question"
                value={citationQuery}
                onChange={(e) => setCitationQuery(e.target.value)}
              />
              {citationErrors.query && <div className="ai-form-error">{citationErrors.query}</div>}
            </div>

            <div className="ai-form-group">
              <label className="ai-form-label">Brand Name <span style={{ color: '#ff601f' }}>*</span></label>
              <input
                type="text"
                className="ai-form-input"
                value={brandName}
                placeholder="Enter the brand Name"
                onChange={(e) => setBrandName(e.target.value)}
              />
              {citationErrors.brandName && <div className="ai-form-error">{citationErrors.brandName}</div>}
            </div>
          </div>
        </DialogContent>
        <DialogActions className="dialog_box_btn" style={{ paddingBottom: '30px' }}>
          <button
            className="ai-submit-btn"
            onClick={async () => {
              let errs = { url: "", query: "", brandName: "" };
              let hasError = false;

              if (citationUrl && !/^(http|https):\/\//.test(citationUrl)) {
                errs.url = "URL must start with http:// or https://";
                hasError = true;
              }

              if (!citationQuery.trim()) {
                errs.query = "Query is mandatory";
                hasError = true;
              }

              if (!brandName.trim()) {
                errs.brandName = "Brand Name is mandatory";
                hasError = true;
              }

              if (hasError) {
                setCitationErrors(errs);
                return;
              }

              setLoading(true);
              try {
                const response = await axios.post(
                  `${process.env.REACT_APP_API_URL}technical/ai_citation_manual_run/`,
                  {
                    "user_domain_id": esodata.domaindata.value.header_selected,
                    "query": citationQuery,
                    "url": citationUrl,
                    "brand_name": brandName
                  },
                  {
                    headers: {
                      Authorization: `${ApiToken}`,
                    },
                  }
                );

                if (response.status === 200 || response.status === 201) {
                  toast.success(response.data?.message || "Report triggered successfully!");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }

                setCitationFormOpen(false);
                setCitationUrl("");
                setCitationQuery("");
                setBrandName("");
                setCitationErrors({ url: "", query: "", brandName: "" });

              } catch (err) {
                console.error(err);
                if (err?.response?.data?.error) {
                  toast.error(err.response.data.error);
                } else {
                  toast.error("Failed to trigger report");
                }
              } finally {
                setLoading(false);
              }
            }}
          >
            Generate Report
          </button>
          <button
            className="ai-reset-btn"
            onClick={() => {
              setCitationFormOpen(false);
              setCitationUrl("");
              setCitationQuery("");
              setBrandName("");
              setCitationErrors({ url: "", query: "", brandName: "" });
            }}
          >
            Cancel
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={citedUrlModalOpen}
        onClose={() => setCitedUrlModalOpen(false)}
        aria-labelledby="cited-url-dialog-title"
        aria-describedby="cited-url-dialog-description"
        className="cited-url-modal"
      >
        <DialogTitle id="cited-url-dialog-title">{selectedPopup === 'citedUrls' ? 'Cited URLs' : 'Competitor URLs'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="cited-url-dialog-description">
            {selectedCitedUrls.length > 0 ? (
              <ul>
                {selectedCitedUrls.map((url, index) => (
                  <li key={index}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {url}
                    </a>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No cited URLs available.</p>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button onClick={() => setCitedUrlModalOpen(false)}>Close</button>
        </DialogActions>
      </Dialog>
    </div >
  );
}
